import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";

export class MermaidContainer extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        this.x = GameConstants.GAME_WIDTH / 2;
        this.y = GameConstants.GAME_HEIGHT * .575;

        this.scaleY = GameVars.scaleY;

        const s = 1.5;

        const niche = new Phaser.GameObjects.Image(this.scene, 0, -210, "texture_atlas_2", "stone_wheel");
        niche.setScale(s);
        this.add(niche);

        const nicheGlow = new Phaser.GameObjects.Image(this.scene, niche.x, niche.y, "texture_atlas_2", "stone_wheel_glow");
        nicheGlow.setScale(s);
        nicheGlow.alpha = .65;
        this.add(nicheGlow);

        this.scene.tweens.add({
            targets: nicheGlow,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 1750,
            yoyo: true,
            repeat: -1
        });

        this.scene.tweens.add({
            targets: [niche, nicheGlow],
            angle: 360,
            ease: Phaser.Math.Easing.Linear,
            duration: 70000,
            repeat: -1
        });

        const mermaid = (this.scene as any).add.spine(0, -120, "mermaid");
        mermaid.scaleX = 1 / GameVars.scaleY;
        mermaid.scaleY = GameVars.scaleY;
        mermaid.skeleton.setToSetupPose();
        mermaid.setSkinByName("default");  
        this.add(mermaid);
        
        mermaid.play("idle color changing", true);
    }
}
 
